import React, { Component, PropTypes } from 'react';
import { withRouter, browserHistory } from 'react-router';
import { connect } from 'react-redux';
import autoBind from 'react-autobind';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import { setAdmin, clearAdminsErrors } from '../actions';
import { cyan900, cyan500 } from 'material-ui/styles/colors';
import Alert from '../components/home/Alert';
import moment from 'moment';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem'; // eslint-disable-line no-unused-vars

const propTypes = {
  dispatch: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  admin: PropTypes.object,
  error: PropTypes.any,
  query: PropTypes.object.isRequired,
};

class AdminNewPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alertOpen: false,
      alertMessage: '',
      error: false,
      required: {
        email: null,
        password: null,
        role: null,
      },
      admin: {
        name: null,
        email: null,
        signupDate: '',
        password: null,
        role: null,
      },
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillMount() {
    if (!this.props.isAuthenticated) {
      browserHistory.goBack();
    }
    const admin = this.state.admin;
    admin.signupDate = moment().format('YYYY-MM-DD');
    this.setState({
      admin,
    });
    this.setRequiredParams();
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.error) {
      this.setState({
        alertOpen: true,
        error: true,
        alertMessage: `${nextProps.error.statusCode} ${nextProps.error.error} ${nextProps.error.message}`,
      });
    }
    if (nextProps.admin && !nextProps.error) {
      this.setState({
        alertOpen: true,
        error: false,
        alertMessage: 'Admin saved successfully!',
      });
    }
    this.setRequiredParams();
  }
  setRequiredParams() {
    const required = this.state.required;
    const admin = this.state.admin;
    Object.keys(this.state.required).forEach((paramName) => {
      const param = admin[paramName];
      required[paramName] = (param == null || param.length === 0 || param === 0) ? 'This field is required' : null;
    });
    this.setState({ required });
  }
  handleSelectChange(event, index, value, target) {
    const admin = this.state.admin;
    admin[target] = value;
    this.setState(admin);
    this.setRequiredParams();
  }
  handleChange(e) {
    const nextState = this.state.admin;
    nextState[e.target.name] = e.target.value;
    this.setState({
      admin: nextState,
    });
    this.setRequiredParams();
  }
  handleSubmit() {
    this.props.dispatch(clearAdminsErrors());
    this.props.dispatch(setAdmin(this.state.admin));
  }
  handleCancel() {
    this.props.dispatch(clearAdminsErrors());
    browserHistory.push('/admins?page=1');
  }
  alertHandleClose() {
    this.setState({
      alertMessage: '',
      alertOpen: false,
    });
    if (!this.state.error) {
      browserHistory.push('/admins?page=1');
    }
  }
  render() {
    const authPage = {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    };
    const styles = {
      floatingLabelStyle: {
        color: cyan900,
      },
      inputStyle: {
        marginRight: '2%',
        width: '250px',
      },
    };
    return (
      <div className="admins component" style={authPage}>
        <h2>New Admin</h2>
        <Alert
          alertOpen={this.state.alertOpen}
          alertHandleClose={() => this.alertHandleClose()}
          alertMessage={this.state.alertMessage}
        />
        <div className="content">
          <div className="float-right">
            <RaisedButton
              label="Cancel"
              style={{ margin: '20px' }}
              primary
              onClick={this.handleCancel}
            />
            <RaisedButton
              label="Save"
              primary
              onClick={this.handleSubmit}
            />
          </div>
          <br />
          <br />
          <TextField
            floatingLabelText="Sign Up Date"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.admin.signupDate}
            name="signupDate"
            disabled
            style={styles.inputStyle}
          />
          <br />
          <TextField
            floatingLabelText="Name"
            floatingLabelStyle={styles.floatingLabelStyle}
            name="name"
            onChange={this.handleChange}
            style={styles.inputStyle}
          />
          <TextField
            floatingLabelText="Password"
            floatingLabelStyle={styles.floatingLabelStyle}
            name="password"
            onChange={this.handleChange}
            style={styles.inputStyle}
            errorText={this.state.required.password}
            errorStyle={{ color: cyan500 }}
            type="password"
          />
          <TextField
            floatingLabelText="Email"
            floatingLabelStyle={styles.floatingLabelStyle}
            name="email"
            onChange={this.handleChange}
            style={styles.inputStyle}
            errorText={this.state.required.email}
            errorStyle={{ color: cyan500 }}
          />
          <SelectField
            value={this.state.admin.role}
            onChange={(event, index, value) => this.handleSelectChange(event, index, value, 'role')}
            floatingLabelText="Role"
            style={{ verticalAlign: 'bottom', marginRight: '2%', width: '250px' }}
            name="role"
            floatingLabelStyle={styles.floatingLabelStyle}
            errorStyle={{ color: cyan500 }}
            errorText={this.state.required.role}
          >
            <MenuItem value={0} primaryText="Superadmin" />
            <MenuItem value={1} primaryText="Admin" />
            <MenuItem value={2} primaryText="Operator" />
            <MenuItem value={3} primaryText="Fulfillment" />
            <MenuItem value={4} primaryText="Read Only" />
          </SelectField>
        </div>
      </div>
    );
  }
}

AdminNewPage.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

AdminNewPage.propTypes = propTypes;

function mapStateToProps(state, ownProps) {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    admin: state.admins.admin,
    error: state.admins.error,
    query: ownProps.location.query,
  };
}

export default withRouter(connect(mapStateToProps)(AdminNewPage));



// WEBPACK FOOTER //
// ./src/containers/AdminNewPage.js